import { createAsyncReducer } from '../../standard-actions/';
import {
    ILoadInternetProductDetailsAction,
    ILoadInternetProductDetailsSuccessAction,
    ILoadInternetProductDetailsErrorAction
} from '../actions/load-internet-product-details';

import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';

export type InternetProductAction
    = ILoadInternetProductDetailsAction
    | ILoadInternetProductDetailsSuccessAction
    | ILoadInternetProductDetailsErrorAction;

const init = (state: IServiceRequestsState, action: InternetProductAction) => ({
    ...state,
    internetProductDetails: {
        ...initialState.internetProductDetails,
        status: action.status,
        data: {
            requestDetail: {
                requestNumber: '',
                requestType: '',
                status: '',
                submitted: '',
                requestedBy: '',
                productType: '',
                asNumber: '',
                maintainedBy: '',
                description: ''
            },
            prefixList: [],
            metaData: {
                totalCount: 0
            }
        }
    }
});

const success = (state: IServiceRequestsState, action: InternetProductAction) => ({
    ...state,
    internetProductDetails: {
        ...initialState.internetProductDetails,
        status: action.status,
        data: (action as ILoadInternetProductDetailsSuccessAction).data
    }
});

const failure = (state: IServiceRequestsState, action: InternetProductAction) => ({
    ...state,
    internetProductDetails: {
        ...initialState.internetProductDetails,
        status: action.status,
        error: (action as ILoadInternetProductDetailsErrorAction).error
    }
});

export const internetProductDetailsReducer = createAsyncReducer(initialState, init, success, failure);

